export default __webpack_public_path__ + "static/media/photo 5.da73ca12.jpg";